import React from 'react';
import '../styles/components/page-header.scss';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, children }) => {
  return (
    <div className="page-header">
      <div className="page-header-content">
        <div className="container">
          <div className="page-header-text">
            <h1 className="page-header-title">{title}</h1>
            {subtitle && <p className="page-header-subtitle">{subtitle}</p>}
          </div>
          {children && <div className="page-header-controls">{children}</div>}
        </div>
      </div>
    </div>
  );
};

export default PageHeader;